import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { adminLogin as apiAdminLogin, adminMe, getAdminToken, setAdminToken } from "../lib/api";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [state, setState] = useState({ status: "checking", email: null });

  const refresh = useCallback(async () => {
    const token = getAdminToken();
    if (!token) {
      setState({ status: "unauthenticated", email: null });
      return;
    }
    try {
      const me = await adminMe();
      setState({ status: "authenticated", email: me.email });
    } catch {
      setAdminToken(null);
      setState({ status: "unauthenticated", email: null });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async ({ email, password }) => {
    const data = await apiAdminLogin({ email, password });
    setAdminToken(data.token);
    setState({ status: "authenticated", email: data.email });
  }, []);

  const logout = useCallback(() => {
    setAdminToken(null);
    setState({ status: "unauthenticated", email: null });
  }, []);

  return (
    <AdminAuthContext.Provider value={{ ...state, login, logout, refresh }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
};
